
class SeeMoreComponent extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.maxHeight = 200;
    this.contentElement = null;
    this.toggleButton = null;
    this.toggleText = null;
    this.onResize = () => this.refreshHeight();
    this.onToggle = () => this.toggle();
  }

  connectedCallback() {
    this.defaultMaxHeight = Number.parseInt(this.dataset.readMoreLength, 10) || 200;
    this.contentElement = this.querySelector('[data-ref="see-more-content"]');
    this.toggleButton = this.querySelector('[data-ref="see-more-toggle"]');
    this.toggleText = this.querySelector('.see-more__toggle-text');

    if (!this.contentElement || !this.toggleButton) return;

    this.contentElement.style.transition = 'max-height 0.3s ease';
    this.refreshHeight();
    this.toggleButton.addEventListener('click', this.onToggle);
    window.addEventListener('resize', this.onResize);

    if (document.fonts) {
      document.fonts.ready.then(() => {
        if (this.isConnected) this.refreshHeight();
      });
    }
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener('click', this.onToggle);
    window.removeEventListener('resize', this.onResize);
  }

  getPreviewHeight() {
    // Conserver le comportement d'origine hors des pages produits.
    if (!window.location.pathname.includes('/products/')) {
      return this.defaultMaxHeight;
    }

    // Couper à la fin du premier paragraphe complet, pas à 200 px.
    const firstParagraph = [...this.contentElement.querySelectorAll('p')]
      .find((paragraph) => paragraph.textContent.trim().length > 0);

    if (!firstParagraph) return this.defaultMaxHeight;

    const contentTop = this.contentElement.getBoundingClientRect().top;
    const paragraphBottom = firstParagraph.getBoundingClientRect().bottom;
    const height = Math.ceil(paragraphBottom - contentTop);

    return height > 0 ? height : this.defaultMaxHeight;
  }

  refreshHeight() {
    if (!this.contentElement || !this.toggleButton) return;

    // Mesurer le contenu entier avant de le replier.
    this.contentElement.style.maxHeight = 'none';
    const actualHeight = this.contentElement.scrollHeight;
    this.maxHeight = this.getPreviewHeight();
    const hasOverflow = actualHeight > this.maxHeight + 2;

    this.toggleButton.style.display = hasOverflow ? '' : 'none';
    this.contentElement.classList.toggle('see-more__content--no-overflow', !hasOverflow);
    this.contentElement.classList.toggle('see-more__content--expanded', hasOverflow && this.isExpanded);
    this.contentElement.style.overflow = hasOverflow ? 'hidden' : '';
    this.contentElement.style.maxHeight = hasOverflow
      ? `${this.isExpanded ? actualHeight : this.maxHeight}px`
      : 'none';
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      this.contentElement.style.maxHeight = `${this.contentElement.scrollHeight}px`;
      this.contentElement.classList.add('see-more__content--expanded');
      if (this.toggleText) {
        this.toggleText.textContent = this.toggleText.dataset.lessText || '↑';
      }
    } else {
      this.contentElement.style.maxHeight = `${this.maxHeight}px`;
      this.contentElement.classList.remove('see-more__content--expanded');
      if (this.toggleText) {
        this.toggleText.textContent = this.toggleText.dataset.moreText || '↓';
      }
    }

    this.dispatchEvent(new CustomEvent('see-more:toggle', {
      detail: { expanded: this.isExpanded },
      bubbles: true,
    }));
  }
}

customElements.define('see-more-component', SeeMoreComponent);
